import _get from "lodash/get";
import { AnyAction } from "redux";
import { BusinessDetails } from "../../../../../models/state";
import { fulfilled, rejected } from "../../utils";
import * as AT from "../actionTypesB2B";

const initialState: BusinessDetails = {
    brregNameSearch: [],
    details: {
        orgNumber: "",
        businessName: "",
        accountName: "",
        street: "",
        streetCO: "",
        postcode: "",
        city: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
    },
    shouldShowInputFields: false,
    shouldShowPBFields: false,
    shouldShowOrgOrNameInputField: true,
    setBusinessDetailsSuccess: false,
};

const reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case AT.B2B_SET_SHOULD_SHOW_ORG_OR_NAME_INPUT:
            return {
                ...state,
                shouldShowOrgOrNameInputField: !!action.value,
            };
        case AT.B2B_SET_SHOULD_SHOW_INPUT_FIELDS:
            return {
                ...state,
                shouldShowInputFields: !!action.value,
            };
        case AT.B2B_SET_SHOULD_SHOW_PB_FIELDS:
            return {
                ...state,
                shouldShowPBFields: !!action.value,
            };
        case AT.B2B_CHECK_ORGANIZATION_NAME:
            return {
                ...state,
                brregNameSearch: action.state,
            };
        case fulfilled(AT.B2B_CHECK_ORGANIZATION_NUMBER):
            return {
                ...state,
                details: action.payload,
                shouldShowInputFields: true,
                shouldShowPBFields: !!_get(action, "payload.boxNumber"),
                shouldShowOrgOrNameInputField: false,
            };
        case rejected(AT.B2B_CHECK_ORGANIZATION_NUMBER):
            return {
                ...state,
                shouldShowInputFields: false,
                shouldShowOrgOrNameInputField: true,
            };
        case fulfilled(AT.B2B_SUBMIT_BUSINESS_DETAILS):
            return {
                ...state,
                setBusinessDetailsSuccess: action.payload.success,
            };
        default:
            return state;
    }
};

export default reducer;
